const FooterData = {
   CompanyWidget: [
      {
         id: 1,
         title: 'Get In Touch',
         description:
            'Don’t miss any updates of our new templates and extensions.!',
      },
   ],
   AboutWidget: [
      {
         id: 1,
         title: 'Download',
         menuItems: [
            {
               id: 1,
               url: '/Comedores',
               text: 'Comedores Asistenciales',
            },
            {
               id: 2,
               url: '#',
               text: 'Android App',
            },
            {
               id: 3,
               url: '#',
               text: 'ios App',
            },
            {
               id: 4,
               url: '#',
               text: 'Desktop',
            },
            {
               id: 5,
               url: '#',
               text: 'Projects',
            },
            {
               id: 6,
               url: '#',
               text: 'My tasks',
            },
         ],
      },
      {
         id: 2,
         title: 'Help',
         menuItems: [
            {
               id: 1,
               url: '#',
               text: 'FAQ',
            },
            {
               id: 2,
               url: '#',
               text: 'Term & conditions',
            },
            {
               id: 3,
               url: '#',
               text: 'Reporting',
            },
            {
               id: 4,
               url: '#',
               text: 'Documentation',
            },
            {
               id: 5,
               url: '#',
               text: 'Support Policy',
            },
            {
               id: 6,
               url: '#',
               text: 'Privacy',
            },
         ],
      },
   ],
   termsCondition: [
      {
         id: 1,
         title: 'Team Solutions',
         menuItems: [
            {
               id: 1,
               url: '#',
               text: 'Support',
            },
            {
               id: 2,
               url: '#',
               text: 'Sales',
            },
            {
               id: 3,
               url: '#',
               text: 'Report Abuse',
            },
            {
               id: 4,
               url: '#',
               text: 'System Status',
            },
         ],
      },
   ],
   SocialLinks: [
      {
         id: 1,
         title: 'Team Solutions',
         menuItems: [
            {
               id: 1,
               url: '#',
               icon: 'ti-facebook',
            },
            {
               id: 2,
               url: '#',
               icon: 'ti-twitter-alt',
            },
            {
               id: 3,
               url: '#',
               icon: 'ti-vimeo-alt',
            },
            {
               id: 4,
               url: '#',
               icon: 'ti-pinterest',
            },
         ],
      },
   ],
   socialIcon: [
      {
         id: 1,
         url: 'https://www.facebook.com/',
         icon: 'ti-facebook',
      },
      {
         id: 2,
         url: '#',
         icon: 'ti-twitter-alt',
      },
      {
         id: 3,
         url: '#',
         icon: 'ti-vimeo-alt',
      },
      {
         id: 4,
         url: '#',
         icon: 'ti-pinterest',
      },
   ],
   TestimonialText: [
      {
         id: 1,
         image: 'new/member_01.jpg',
         description:
            "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
         authorName: 'Phillip Anthropy',
         authorPost: 'UI/UX designer',
      },
      {
         id: 2,
         image: 'new/member_01.jpg',
         description:
            "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
         authorName: 'Phillip Anthropy',
         authorPost: 'UI/UX designer',
      },
      {
         id: 3,
         image: 'new/member_01.jpg',
         description:
            "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
         authorName: 'Phillip Anthropy',
         authorPost: 'UI/UX designer',
      },
      {
         id: 4,
         image: 'new/member_01.jpg',
         description:
            "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
         authorName: 'Phillip Anthropy',
         authorPost: 'UI/UX designer',
      },
   ],
   aboutLinks: [
      {
         id: 1,
         url: '#',
         item: 'Developer',
      },
      {
         id: 2,
         url: '#',
         item: 'Blog',
      },
      {
         id: 3,
         url: '#',
         item: 'Investor',
      },
      {
         id: 4,
         url: '#',
         item: 'Sitemap',
      },
      {
         id: 5,
         url: '#',
         item: 'Jobs',
      },
   ],
   helpLinks: [
      {
         id: 1,
         url: '#',
         item: 'Help and Contact',
      },
      {
         id: 2,
         url: '#',
         item: 'Fees',
      },
      {
         id: 3,
         url: '#',
         item: 'Security',
      },
      {
         id: 4,
         url: '#',
         item: 'App',
      },
      {
         id: 5,
         url: '#',
         item: 'Shop',
      },
   ],
   PrivacyLinks: [
      {
         id: 1,
         url: '#',
         item: 'Privacy Policy',
      },
      {
         id: 2,
         url: '#',
         item: 'Legal Agreement',
      },
      {
         id: 3,
         url: '#',
         item: 'Feedback',
      },
   ],
   about: [
      {
         id: 1,
         url: '/Comedores',
         text: 'Comedores Asistenciales',
      },
      {
         id: 2,
         url: '/Primeros',
         text: 'Atención Alimentaria en los Primeros 1,000 días',
      },
      {
         id: 3,
         url: '/Paap',
         text: 'PAAGP ',
      },
      {
         id: 4,
         url: '/Talleres',
         text: 'Talleres',
      },,
      {
         id: 5,
         url: '/Alimentacion',
         text: 'Alimentación Escolares',
      },
      {
         id: 6,
         url: '/DesarrolloComunitario',
         text: 'Desarrollo Comunitario',
      },
   ],
   Solution: [
      {
         id: 1,
         url: '/Caic',
         text: 'CAIC',
      },
      {
         id: 2,
         url: '/Odontologia',
         text: 'Odontología',
      },
      {
         id: 4,
         url: '/Juridico',
         text: 'Jurídico',
      },
      {
         id: 5,
         url: '/Psicologo',
         text: 'Psicología',
      },
      {
         id: 6,
         url: '/Ubr',
         text: 'UBR',
      },
      {
         id: 7,
         url: '/Nutricion',
         text: 'Nutrición',
      }
   ],
   teamSolution: [
      {
         id: 1,
         url: '/',
         text: 'Inicio',
      },
      {
         id: 2,
         url: '/VisionMision',
         text: 'Misión y Visión',
      },
      {
         id: 3,
         url: '/Programas',
         text: 'Programas',
      },
      {
         id: 4,
         url: '/Servicios',
         text: 'Servicios',
      },
      {
         id: 5,
         url: '/Transparencia',
         text: 'Transparencia',
      },
      {
         id: 6,
         url: '/AvisoPrivacidad',
         text: 'Aviso de Privacidad',
      },
      {
         id: 7,
         url: '/Terminos y Condiciones',
         text: 'Términos y Condiciones',
      },
   ],
};
export default FooterData;
